var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 120.158C128.812 120.035 129.161 119.423 128.947 118.86C125.582 109.996 118.689 102.179 109.243 96.5408C99.4189 90.6779 87.3824 87.5 74.9998 87.5C62.6173 87.5 50.5808 90.6779 40.757 96.5408C31.3106 102.178 24.4179 109.996 21.0528 118.86C20.839 119.423 21.188 120.035 21.7776 120.158L66.839 129.549C72.2217 130.671 77.7779 130.671 83.1607 129.549L128.222 120.158Z",
    fill: "#5664D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 50,
    r: 31.25,
    fill: "#5664D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fca8769b4bd5287c43353726d57fcb9a.svg";
export { ForwardRef as ReactComponent };